import {
  SET_FULL_ACCESS,
  FullAccessTypes,
} from '../actions/fullaccess.actions';

const initialState: boolean = null;

const FullAccessReducer = (
  state = initialState,

  action: FullAccessTypes
): boolean => {
  const { payload } = action;

  switch (action.type) {
    case SET_FULL_ACCESS:
      return payload.access;

    default:
      return state;
  }
};

// eslint-disable-next-line import/prefer-default-export
export { FullAccessReducer };
